import { Component } from '../lib/ComponentBase';
import { registerComponent } from '../lib/ComponentHelpers';
import HexCoords from '../grid/HexCoords';
import type { Bearing } from '../grid/HexBearing';
import type { ActionDetails, ActionDetailsJSON } from '../lib/Action';
import { ActionType } from '../lib/Action';

class IntendsToAct extends Component {
  actionType: ActionType;
  details: ActionDetails;
  sourceComponentName?: string;

  constructor(data: { actionType: ActionType, details: ActionDetailsJSON, sourceComponentName?: string } = { actionType: ActionType.IDLE, details: {} }) {
    super();
    this.actionType = data.actionType;
    // Hydrate coords if present in details
    this.details = {
      ...data.details,
      coords: data.details.coords ? HexCoords.get(data.details.coords) : undefined,
    };
    this.sourceComponentName = data.sourceComponentName;
  }

  equals(other: this): boolean {
    // Compare actionType
    if (this.actionType !== other.actionType) return false;

    // Compare sourceComponentName
    if (this.sourceComponentName !== other.sourceComponentName) return false;

    // Validate that coords is properly hydrated if present
    if (this.details.coords) {
      if (!(other.details.coords instanceof HexCoords)) {
        console.error(`IntendsToAct.equals: other.details.coords is not a HexCoords instance`, other.details.coords);
        return false;
      }
    }

    // Compare details using JSON (includes coords comparison)
    return JSON.stringify(this.toJSON().details) ===
           JSON.stringify(other.toJSON().details);
  }

  static getTestInstances(): IntendsToAct[] {
    return [
      new IntendsToAct({ actionType: ActionType.IDLE, details: {} }),
      new IntendsToAct({ actionType: ActionType.MOVE, details: { coords: { q: 1, r: 0 } }, sourceComponentName: 'MoveForward' }),
      new IntendsToAct({ actionType: ActionType.TURN, details: { bearing: 3 }, sourceComponentName: 'Turn' }),
    ];
  }
}

export default registerComponent(IntendsToAct);
